(() => {
  'use strict';

  const honeyDropsByTier = Object.freeze({
    15: 1,
    20: 2,
    25: 3,
    30: 4,
    35: 5
  });

  const buildFact = (className, value, label) => {
    const element = document.createElement('span');
    element.className = className;

    const number = document.createElement('strong');
    number.textContent = String(value);

    element.append(number, document.createTextNode(` ${label}`));
    return element;
  };

  const enhanceTierCard = (card) => {
    if (!card || card.dataset.tierClarityEnhanced === 'true') return;

    const heading = card.querySelector('.tier-body h3');
    const price = card.querySelector('.tier-body > .price');
    const itemMatch = heading?.textContent.match(/\b(15|20|25|30|35)\b/);
    const itemCount = Number(itemMatch?.[1]);
    const honeyCount = honeyDropsByTier[itemCount];

    if (!heading || !price || !itemCount || !honeyCount) return;

    const priceText = price.textContent.trim();
    const honeyLabel = `Honey Drop${honeyCount === 1 ? '' : 's'}`;

    card.dataset.tierClarityEnhanced = 'true';
    card.classList.remove('featured');
    card.querySelector('.ribbon')?.remove();

    const facts = document.createElement('div');
    facts.className = 'tier-facts';
    facts.setAttribute(
      'aria-label',
      `${itemCount} items, ${priceText}, ${honeyCount} ${honeyLabel}`
    );

    const factPrice = document.createElement('strong');
    factPrice.className = 'tier-facts__price';
    factPrice.textContent = priceText;

    const details = document.createElement('div');
    details.className = 'tier-facts__details';

    const itemFact = buildFact('tier-facts__items', itemCount, 'items');
    const honeyFact = buildFact('tier-facts__honey', honeyCount, honeyLabel);

    details.append(itemFact, honeyFact);
    facts.append(factPrice, details);
    heading.insertAdjacentElement('afterend', facts);

    price.hidden = true;

    const listItems = card.querySelectorAll('.tier-body ul li');
    if (listItems[0]) {
      listItems[0].textContent = `${itemCount} curated surprise items`;
    }
    if (listItems[1]) {
      listItems[1].textContent =
        `${honeyCount} guaranteed premium ${honeyLabel}`;
    }
  };

  const enhanceTierCards = () => {
    document.querySelectorAll('.tier-card').forEach(enhanceTierCard);
  };

  const ensureBuzzyBonusStyles = () => {
    if (document.getElementById('sassyBuzzyBonusCtaStyles')) return;

    const style = document.createElement('style');
    style.id = 'sassyBuzzyBonusCtaStyles';
    style.textContent = `
      .buzzy-bonus-card__cta {
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid rgba(194, 140, 65, .24);
        text-align: center;
      }
      .buzzy-bonus-card__support {
        max-width: 30rem;
        margin: 0 auto .9rem;
        color: #6a5044;
        font-size: .95rem;
        line-height: 1.5;
      }
      .buzzy-bonus-card__button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-height: 46px;
        padding-inline: 1.2rem;
      }
    `;
    document.head.appendChild(style);
  };

  const addBuzzyBonusCta = () => {
    const cards = document.querySelectorAll(
      '#sassyHiveApp .page[data-page="how-it-works"] .compare-card'
    );
    const card = [...cards].find((item) =>
      item.querySelector('h3')?.textContent.trim() === 'Buzzy Bonus Charms'
    );

    if (!card || card.dataset.buzzyBonusCtaEnhanced === 'true') return;

    ensureBuzzyBonusStyles();
    card.dataset.buzzyBonusCtaEnhanced = 'true';

    const cta = document.createElement('div');
    cta.className = 'buzzy-bonus-card__cta';

    const support = document.createElement('p');
    support.className = 'buzzy-bonus-card__support';
    support.textContent =
      'Discover the tiny charms that add an extra buzz to your Mystery Box.';

    const link = document.createElement('a');
    link.className = 'btn btn-secondary btn-sm buzzy-bonus-card__button';
    link.href = '#buzz-bonuses';
    link.textContent = 'Meet the Buzzy Bonuses';

    cta.append(support, link);
    card.appendChild(cta);
  };

  const enhanceClarity = () => {
    enhanceTierCards();
    addBuzzyBonusCta();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceClarity, { once: true });
  } else {
    enhanceClarity();
  }

  window.addEventListener('sassy:core-ready', enhanceClarity);
  window.addEventListener('hashchange', () => {
    window.requestAnimationFrame(enhanceClarity);
  });
  document.addEventListener('shopify:section:load', enhanceClarity);
})();
